import { getServicePathToAPI, joinURLPath } from '@sigma-frontend-libs/commons'

import { generateServices, globalErrorHandler, request, services } from '@/utils'

import render from './render'

const pathToAPI = getServicePathToAPI(services['otp-settings/channels'])
const serviceNameViaPoint = services['otp-settings/widgets'].split('/').join('.')

export default {
  name: 'Channels',

  mixins: [
    generateServices({
      name: services['otp-settings/channels'],

      backendGeneration: 'nest',

      get: false,
      create: false,
      update: false,
      remove: false
    })
  ],

  props: {
    UserId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      otpChannelsSettings: []
    }
  },

  computed: {
    $disabled() {
      return this.filteredChannels.length === 0
    }
  },

  async mounted() {
    await this.rest[services['otp-settings/channels']].find()
    await this.getChannels()
  },

  methods: {
    async getChannels() {
      try {
        this.loading = false
        const data = await request.get(joinURLPath(pathToAPI, 'user-channels', this.UserId || this.$route.params.id))
        if (data) {
          this.otpChannelsSettings = data.map(({ otpChannelSettingsId }) => {
            return { otpChannelSettingsId }
          })
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    },

    async attachChannels() {
      try {
        this.loading = true
        const data = await request.update(
          joinURLPath(pathToAPI, 'user-channels', this.UserId || this.$route.params.id, 'bulk'),
          {
            body: {
              otpChannelsSettings: this.otpChannelsSettings.filter(({ otpChannelSettingsId }) => {
                return !!otpChannelSettingsId
              })
            }
          }
        )
        if (data) {
          this.addSnackbar({
            text: this.getTranslate(`${serviceNameViaPoint}.snackbars.channels.attached`),
            type: 'success'
          })
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
